"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useEffectEvent, useReducer } from "react";
import { getTimeAgoShort } from "@/helpers/Helpers";
interface BrainLeftSidebarWaveDropTimeProps {
  readonly time: number;
}
const BrainLeftSidebarWaveDropTime: React.FC<BrainLeftSidebarWaveDropTimeProps> = t0 => {
  const $ = _c(12);
  const {
    time
  } = t0;
  const [, forceRefresh] = useReducer(_temp, 0);
  let t1;
  if ($[0] !== forceRefresh) {
    t1 = () => {
      forceRefresh();
    };
    $[0] = forceRefresh;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const refreshNow = useEffectEvent(t1);
  let t2;
  if ($[2] !== refreshNow) {
    t2 = () => {
      const intervalId = window.setInterval(() => {
        refreshNow();
      }, 60000);
      return () => {
        window.clearInterval(intervalId);
      };
    };
    $[2] = refreshNow;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== refreshNow) {
    t4 = () => {
      const handleVisibilityChange = () => {
        if (document.visibilityState === "visible") {
          refreshNow();
        }
      };
      const handleFocus = () => {
        refreshNow();
      };
      document.addEventListener("visibilitychange", handleVisibilityChange);
      window.addEventListener("focus", handleFocus);
      return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        window.removeEventListener("focus", handleFocus);
      };
    };
    $[5] = refreshNow;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [];
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  useEffect(t4, t5);
  let t6;
  if ($[8] !== time) {
    t6 = getTimeAgoShort(time);
    $[8] = time;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const label = t6;
  let t7;
  if ($[10] !== label) {
    t7 = <span className="tw-text-iron-300">{label}</span>;
    $[10] = label;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};
export default BrainLeftSidebarWaveDropTime;
function _temp(value) {
  return value + 1;
}